import BlockTop from "./blocks/BlockTop";
import FormLottery from "./blocks/FormLottery";
import React from "react";
import ResultDay from "../../results/day/ResultDay";
import ResultNight from "../../results/night/ResultNight";
import { getDateSlash } from "../../../utility/DateUtils";
import Banner from "./blocks/Banner";
import _ from "lodash";
import Waiting from "./blocks/Waiting";

const MidSide = (props) => {
  const { results: { list:{items, nextDraw} }, draw} = props;
  return (
    <td>
      <div id="right_main">
        <table width="100%">
          <tbody>
            <tr>
              <td className="main">
                <BlockTop />
                <div className="mainbody">
                  <div id="noidung">
                    <h1 className="pagetitle">
                      KẾT QUẢ XỔ SỐ KIẾN THIẾT {getDateSlash()}
                    </h1>
                    {(_.isEmpty(draw) && nextDraw) && <Waiting nextDraw={nextDraw}/>}
                    <div className="box_mienuutien">
                      <FormLottery />
                    </div>
                    {items?.map((items, i) => {
                      return (
                        <div key={i}>
                          {items?.isNight ? (
                            <ResultNight items={items} {...props} indexResult={i}/>
                          ) : (
                            <ResultDay
                              indexResult={i}
                              items={items}
                              {...props}
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
                <Banner num="1"/>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </td>
  );
};

export default MidSide;
